/**
 * File skip-link-focus-fix.js.
 *
 * Helps with accessibility for keyboard only users.
 *
 * Learn more: https://git.io/vWdr2
 */
export default function () {
  const isIe = /(trident|msie)/i.test(navigator.userAgent);

  if (isIe && document.getElementById && window.addEventListener) {
    window.addEventListener(
      "hashchange",
      function () {
        const id = location.hash.substring(1);

        if (!/^[A-z0-9_-]+$/.test(id)) return;

        const element = document.getElementById(id);

        if (!element) return;

        if (!/^(?:a|select|input|buttonextarea)$/i.test(element.tagName)) {
          element.tabIndex = -1;
        }

        element.focus();
      },
      false
    );
  }
};
